export const commaDelimit = (elements: string[] | null = [], delimiter = ','): string =>
  elements?.join(`${delimiter} `) ?? '';

export const capitalizeFirstLetters = (str: string): string =>
  str
    ?.split(' ')
    .map(i => i.charAt(0).toUpperCase() + i.slice(1).toLowerCase())
    .join(' ');
